import { getCreditPricing } from "@punchup/data/models";

import { TierCard } from "./types";

/**
 * Buy Credits tier cards, gate-aware. `updatedPricing` mirrors the resolved
 * `updated_credits_pricing` Statsig gate (passed down as a prop — ui-common
 * never reads product gates directly, see docs/specs/statsig.md). Old arm
 * keeps today's copy/pricing byte-for-byte; new arm reflects the
 * updated-pricing prices and copy.
 */
export function getTierCards(updatedPricing: boolean): TierCard[] {
  const pricing = getCreditPricing(updatedPricing);
  return [
    {
      tier: "starter",
      credits: `${pricing.amounts.starter.toLocaleString()} credits`,
      features: updatedPricing
        ? ["10k emails", "1k texts"]
        : ["10k emails", "500 texts"],
      amount: pricing.prices.starter,
    },
    {
      tier: "pro",
      credits: `${pricing.amounts.pro.toLocaleString()} credits`,
      features: updatedPricing
        ? ["100k emails", "10k texts"]
        : ["100k emails", "5k texts"],
      amount: pricing.prices.pro,
    },
  ];
}

/** Shown in the checkout form's success block once a credits payment goes through. */
export const CREDITS_PAYMENT_SUCCESS_COPY =
  "Your credits will be available within a few seconds.";
